exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".integer-setting_space_Ps3kB {\n    margin-right: 0.5em;\n}\n\n.integer-setting_label_11Wy2 {\n    height: 32px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}", ""]);

// exports
exports.locals = {
	"space": "integer-setting_space_Ps3kB",
	"label": "integer-setting_label_11Wy2"
};